import type { VFC } from 'react';
import styled from 'styled-components';
import { parseMaybeRegExp } from '../form/TreeSelect/utils/parseMaybeRegExp';
import { removeAccents } from '../../utils/string/removeAccents';

export interface HighlighterProps {
  originalText?: string;
  highlightedText?: string;
  color?: string;
}

const HighlightedText = styled.span`
  color: ${({ theme, color }) => color ?? theme.color.theme.tertiary};
  font-weight: ${({ theme }) => theme.font.weight.bold};
`;

export const Highlighter: VFC<HighlighterProps> = ({ originalText, highlightedText: searchValue, color }) => {
  if (searchValue === undefined || searchValue === '') {
    return <>{originalText}</>;
  }
  const regex = parseMaybeRegExp(removeAccents(searchValue.trim()) ?? '');
  const regexWithCaptureGroup = new RegExp(`(${regex.source})`, 'gi');
  const parts = originalText?.split(regexWithCaptureGroup);

  return (
    <>
      {parts?.map((part, index) =>
        regexWithCaptureGroup.test(part) ? (
          <HighlightedText key={`${part}-${index.toString()}`} color={color}>
            {part}
          </HighlightedText>
        ) : (
          <span key={`${part}-${index.toString()}`}>{part}</span>
        ),
      )}
    </>
  );
};
